export const SosFasttEspaceAgencesRequestKeys = {
    GET_MISSION_STATEMENT_INFORMATIONS: "GET_MISSION_STATEMENT_INFORMATIONS",
    REFUSE_MISSION_STATEMENT_INFORMATIONS: "REFUSE_MISSION_STATEMENT_INFORMATIONS",
    VALIDATE_MISSION_STATEMENT_INFORMATIONS: "VALIDATE_MISSION_STATEMENT_INFORMATIONS",
}
